export default "__VITE_ASSET__Cwp9vEBr__"